/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import PageContext from "@PageContext";
import WebProfile from "@micado-digital/react-ui/components/WebProfile";
import AccountData from "@micado-digital/react-ui/components/AccountData";
import UiContext from "@UiContext";
import useConsent from "../hooks/useConsent";
import PageTransition from "@micado-digital/react-ui/components/PageTransition";
import Locals from "@micado-digital/react-ui/components/Locals";
import useIsCurrentLocation from "@micado-digital/react-ui/hooks/useIsCurrentLocation";
import useTheme from "@material-ui/core/styles/useTheme";
import Animation from "@Components/views/Animation";
import Header from "@Components/views/Header";
import Default from "./Default";

import styles from "./Views.styles";

const Footer = loadable(() => import("@Components/views/Footer"));
const ReactMetaData01 = loadable(() =>
	import("@micado-digital/react-metadata/ReactMetadata01")
);
const Tracking = loadable(() => import("./Tracking"));

const Views = () => {
	const { REACT_APP_PATH } = process.env;
	const [pageData] = useContext(PageContext);
	const { authorID, id, lang, layoutTag, layoutVariant, meta = {} } = pageData;
	const [ui, setUi] = useContext(UiContext);
	const { _location } = ui;
	const consent = useConsent();
	const theme = useTheme();
	const currentLocation = useIsCurrentLocation();
	const css = styles();
	const {
		palette: {
			primary: { light: primaryMainColor }
		}
	} = theme;
	const hasAnimation = layoutVariant !== "no-animation" && layoutVariant !== "store-locator";

	useEffect(() => {
		const hash = document.URL.split("#")[1];

		if (hash) {
			setTimeout(() => {
				const $target = document.querySelector(`[data-anchor="${hash}"]`);

				if ($target) {
					$target.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			}, 100);
		}

		setUi(prevState => ({
			...prevState,
			desktopMenuOpen: false,
			desktopCurrentLevel1ID: null,
			mobileMenuOpen: false,
			searchOpen: false
		}));
	}, [_location]);

	if (!lang) return null;

	const {
		canonical: metaCanonical,
		description: metaDescription,
		indexable: metaIndexable,
		image: metaImage,
		keywords: metaKeywords,
		lat: metaLat,
		links: metaLinks,
		lng: metaLng,
		title: metaTitle
	} = meta;

	return (
		<WebProfile>
			<AccountData authorID={authorID}>
				<Locals url={`/locals/${lang || "de"}.json`}>
					<div
						className={clsx(css.page, "mco-page", {
							[css.pageIntro]: layoutVariant === "intro",
							"mco-page--intro": layoutVariant === "intro"
						})}
					>
						<Header />
						{hasAnimation && <Animation />}
						<PageTransition color={primaryMainColor} position="top" />
						{layoutTag === "default" && <Default />}
						{currentLocation && <Footer lang={lang} />}
						<micado-ial
							key={consent}
							language={lang}
							path={REACT_APP_PATH}
							page-id={id}
						></micado-ial>
					</div>
					<ReactMetaData01
						canonical={metaCanonical}
						description={metaDescription}
						index={metaIndexable}
						image={metaImage}
						keywords={metaKeywords}
						lat={metaLat}
						lang={lang}
						links={metaLinks}
						lng={metaLng}
						title={metaTitle}
					/>
					<Tracking />
				</Locals>
			</AccountData>
		</WebProfile>
	);
};

export default Views;
